import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IUtilityFilterSelectProps {
    value: (number | string)[];
    onChange: (value: (number | string)[]) => void;
    options: ISelectOption<number | string>[];
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    isLoading?: boolean;
}

export const UtilityFilterSelect: React.FC<IUtilityFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 300,
    disabled = false,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            selectedCountInLabel
            multiple
            showSelectAllOption={false}
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            loading={isLoading}
            label={label}
            height={height}
        />
    );
};
